import { useTheme } from "../App.jsx";
import { APP_STORE_URL, LANDING_URL } from "../lib/links.js";

// Phone-width visitors get this instead of a web app: on phones, Follow the
// Leader is the iPhone app (Google Play isn't live yet). Web sign-up and
// Stripe checkout are desktop-only by product decision. Until App Review
// approves the app, APP_STORE_URL is empty and the button reads "Coming soon".
const FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

export default function GetTheApp() {
  const C = useTheme();
  return (
    <div style={{
      minHeight: "100%", display: "flex", alignItems: "center", justifyContent: "center",
      background: C.bg, color: C.text, fontFamily: FONT, padding: "40px 24px",
    }}>
      <div style={{ maxWidth: 380, textAlign: "center" }}>
        <img src="/brand/ftl-mark-small.svg" alt="" width={40} height={40} style={{ marginBottom: 20 }} />
        <h1 style={{ fontSize: 26, fontWeight: 700, letterSpacing: -0.5, lineHeight: 1.2, margin: "0 0 12px" }}>
          Follow the Leader is an iPhone app
        </h1>
        <p style={{ fontSize: 15.5, lineHeight: 1.55, color: C.textMuted, margin: "0 0 28px" }}>
          Get alerts the moment a top Polymarket trader makes an unusually large move,
          right on your phone.
        </p>

        {APP_STORE_URL ? (
          <a href={APP_STORE_URL} style={{
            display: "inline-block", background: C.green, color: C.bg, fontWeight: 600,
            fontSize: 16, padding: "14px 26px", borderRadius: 12, textDecoration: "none",
          }}>
            Download on the App Store
          </a>
        ) : (
          <div style={{
            display: "inline-block", border: `1px solid ${C.border}`, color: C.textMuted,
            fontSize: 14, padding: "10px 18px", borderRadius: 999,
          }}>
            Coming soon to the App Store
          </div>
        )}

        <p style={{ fontSize: 13.5, lineHeight: 1.5, color: C.textMuted, marginTop: 28 }}>
          Subscribed on the web? Sign in on a computer, or use the same account in the iPhone app.
        </p>
        <p style={{ fontSize: 12, color: C.textDim, marginTop: 24 }}>
          <a href={LANDING_URL} style={{ color: C.textMuted }}>followtheleader.app</a>
          {" · "}Not financial advice · Not affiliated with or endorsed by Polymarket
        </p>
      </div>
    </div>
  );
}
